var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.data.length > 0
        ? _c(
            "div",
            { staticClass: "order-wrap" },
            [
              _c(
                "el-card",
                { staticClass: "order-card horizontal-copy" },
                _vm._l(_vm.data, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "order-item" },
                    [
                      _c("span", [_vm._v(_vm._s(item.source) + " ")]),
                      _c("span", [_vm._v(_vm._s(item.xhname) + " ")]),
                      _c("span", [_vm._v(_vm._s(item.num) + "套 ")]),
                      _c("span", [_vm._v(_vm._s(item.price))]),
                    ]
                  )
                }),
                0
              ),
              _c(
                "el-card",
                { staticClass: "order-card horizontal-copy" },
                _vm._l(_vm.data, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "order-item" },
                    [
                      _c("span", [_vm._v(_vm._s(item.source) + " ")]),
                      _c("span", [_vm._v(_vm._s(item.xhname) + " ")]),
                      _c("span", [_vm._v(_vm._s(item.num) + "套")]),
                    ]
                  )
                }),
                0
              ),
              _c("el-card", { staticClass: "order-card vertical-copy" }, [
                _c("div", { staticClass: "table-fake" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    _vm._l(_vm.data, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "col-item" },
                        [_vm._v(_vm._s(item.source))]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    _vm._l(_vm.data, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "col-item" },
                        [_vm._v(_vm._s(item.xhname))]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    _vm._l(_vm.data, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "col-item" },
                        [_vm._v(_vm._s(item.num) + "套")]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    _vm._l(_vm.data, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "col-item" },
                        [_vm._v(_vm._s(item.price))]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ],
            1
          )
        : _c("el-empty", { attrs: { "image-size": 200 } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }